import { create } from "zustand";
import { persist } from "zustand/middleware";

const store = create(
  persist(
    (set) => ({
      user: null,
      setUser: user => set(() => ({user})),
      metrics: null,
      setMetrics: metrics => set(() => ({metrics})),
    }),
    {
      name: "state",
    }
  )
)

export default store;
